import React, { useState } from "react";
import bg from "../../../assets/images/yzqf/qsgc-bg.jpg";
import cls from 'classnames';
import Slider from 'react-slick';
const Detail = ({ setType, type }) => {
  // const typesmallimg = Array(4)
  //   .fill()
  //   .map((_, index) =>
  //     require(`../../../assets/images/yzqf/qsgc-typesmall${index + 1}.png`)
  //   );
  const typeimgactive = Array(5)
    .fill()
    .map((_, index) =>
      require(`../../../assets/images/yzqf/qsgc-typesmall${index + 1
        }-active.png`)
    );
  const typedetailimg = [1, 4, 5, 6].map((_) =>
    require(`../../../assets/images/yzqf/qsgc-typecont${_}.png`)
  );

  const typedetail1 = [
    {
      cont: `<p>在重庆及整个巴蜀地区还出土有大量汉晋时期的各式乐舞俑。在这些乐舞形象中，乐器组合常见的有琴、瑟、箫、鼓、埙等。其中的“抚琴俑”所用乐器究竟是琴、瑟还是筝，说法不一，但可以肯定的是，当时常用的不止一种拨弦乐器，其中包括与传世古琴很接近的类型。说明当时的富裕阶层在宴乐中欣赏琴曲，或者以琴伴奏是比较流行的，而且极有可能拥有一批专职琴师。西晋左思的《蜀都赋》曾用“巴姬弹弦，汉女击节”来描写蜀中豪绅们宴饮娱乐的场景，可见巴蜀民间琴乐之兴盛。</p>
      <img src="${typedetailimg[0]}" />`,
    },
    {
      cont: `<p>唐代，“人家多种橘，风土爱弹琴”是巴蜀地区的特色风景。</p><p>与重庆古琴相关的，最为琴人所熟知的，是在唐代古诗中被多次提及的琴曲《三峡流泉》。李白的《答杜秀才五松见赠》一诗中有“一时相逢乐在今，袖拂白云开素琴，弹为三峡流泉音”之句。岑参的《秋夕听罗山人弹三峡流泉》将听此曲时如身临空山之境的所感所思直白道来：</p>
      <div class='poetrybox'>
        <div>皤皤岷山老，抱琴鬓苍然。衫袖拂玉徽，为弹三峡泉。</div>
        <div>此曲弹未半，高堂如空山。石林何飕照，忽在窗户间。</div>
        <div>绕指弄呜咽，青丝激潺溪。演漾怨楚云，虚徐韵秋烟。</div>
        <div>疑兼阳台雨，似杂巫山猿。幽引鬼神听，净令耳目便。</div>
        <div>楚客肠欲断，湘妃泪斑斑。谁裁青桐枝，组以朱丝弦。</div>
        <div>能含古人曲，递与今人传。知音难再逢，惜君方老年。</div>
        <div>曲终月已落，惆怅东斋眠。</div>
      </div>
      <p>据学者推测，琴曲《三峡流泉》大约成形于东晋至唐初，主要流行于巴蜀地区。安史之乱后，该曲曾一度广泛流行于士人之间，多传于文士与友人雅集唱和之时，后因不同人的演绎而变奏为两曲。至宋代，文人将“高山流水”的典故附会于曲上，由是更易曲名。至明代，琴人所收琴谱因流传日久而面貌不一，遂有《高山》《流水》之别。以上推测尚有待进一步的实证进行检验，然《三峡流泉》的意义不应只停留在文学史上，它作为古琴文化的代表元素，是中国文人山水情结的集中体现，也对研究重庆地区的古琴文化具有重要意义。</p>`,
    },
    {
      cont: `<p>宋明以后，随着各类方志、笔记文献的增多，具名的重庆琴人已有明确记载，兹就目前所收集到的重庆籍人物列表如下：</p>
      <table border="1">
        <tbody>
          <tr>
            <th>姓名</th>
            <th>年代</th>
            <th>籍贯</th>
            <th class='last'>人物介绍</th>
          </tr>
          <tr>
            <td>阳枋</td>
            <td>南宋</td>
            <td>合州</td>
            <td>
              字正父，号字溪，淳祐元年（1241年）赐同进士出身，曾任绍庆府学官。有诗句“地阔天宽人一般，琴心会得语言难。高山流水知音少，月白风清时自弹”。另有文述其“生平所储，惟书数卷，琴一张”，“每良天佳月……编《易》张琴，水边林下，行吟坐啸，乐其自乐”，“琴书自娱，无他玩好”。
            </td>
          </tr>
          <tr>
            <td>来知德</td>
            <td>明代</td>
            <td>梁山</td>
            <td>
              字矣鲜，嘉靖三十一年（1552年）举人。有诗句“援琴鸣弦写寂寥”“流水高山半调琴”“我有孙枝琴，龙凤蟠唇足。不向人间弹，往往寻幽独。朝弹露下松，暮弹月下竹。君侯知我音，五马来空谷。投我白雪篇，掷我阳春曲。感君缠绵意，徽上写不出。为君再三弹，再三山水绿”。
            </td>
          </tr>
          <tr>
            <td>李谏</td>
            <td>明代</td>
            <td>合州</td>
            <td>
              字诚轩，嘉靖年间举人，初仕高邑县，为官清廉，治平有方，致仕归乡后效仿陶渊明隐于田园，“暇日与田野农民杯酒笑傲，弹琴种花，有彭泽遗意”。
            </td>
          </tr>
          <tr>
            <td>罗廷唯</td>
            <td>明代</td>
            <td>永川</td>
            <td>
              字会甫，嘉靖癸丑年（1553年）进士，官至御史，善琴，撰有《琴音古选》。
            </td>
          </tr>
          <tr>
            <td>杨正经</td>
            <td>明代</td>
            <td>酉阳</td>
            <td>
              字怀玉，擅音律，崇祯时任太常寺卿，有御赐二琴，曾作《西方思》《风木悲》二操。崇祯皇帝称其琴艺“过于师襄”，明末清初的文人对其记述甚多，并有数首听琴诗流传于世。王士祯记其“鼎革后，携赐琴流转吴越间，文士多为赋诗，绝似宋末汪水云也”。
            </td>
          </tr>
          <tr>
            <td>陈树藩</td>
            <td>清代</td>
            <td>丰都</td>
            <td>字艺塘，廪生，善琴，工书画。</td>
          </tr>
          <tr>
            <td>马宗大</td>
            <td>清代</td>
            <td>石柱</td>
            <td>
              字应侯，石柱土司，工诗画，善琴操，“子光裕、犹子光裁、孙孔昭皆善书能诗，兼工图章琴棋，秉家训也”。
            </td>
          </tr>
          <tr>
            <td>彭万官</td>
            <td>清代</td>
            <td>万县</td>
            <td>
              字庆莲，乾隆年间北京宜庆部旦角，工琴。时人将其琴艺与陈银官的戏法、王桂官画兰并称为“梨园三妙”。
            </td>
          </tr>
          <tr>
            <td>冉性山</td>
            <td>清代</td>
            <td>重庆</td>
            <td>
              字清真，业医，好道，曾以《孤猿晓月》《佩兰》传曲武进琴家韩桂。
            </td>
          </tr>
          <tr>
            <td>郑钗香</td>
            <td>清代</td>
            <td>巴县</td>
            <td>节妓，貌妍心慧，工弹唱，能鼓七弦琴，堪称绝技。</td>
          </tr>
          <tr>
            <td>竹禅</td>
            <td>清代</td>
            <td>梁山</td>
            <td>
              俗姓王，梁山双桂堂僧。谙书画，喜操缦，以《普庵咒》《忆故人》《白雪》《风雷引》《高山》《流水》等曲最为精彩。由其传谱的琴曲《忆故人》在1937年编印的《今虞琴刊》上登载之后，广受琴人青睐。寓居武汉期间，传琴甚众，曾托汉阳钢铁厂代铸铜琴一张，声音铿锵洪亮。
            </td>
          </tr>
          <tr>
            <td>谢云生</td>
            <td>清末民初</td>
            <td>璧山</td>
            <td>
              民国五、六年期间，与龙琴舫等在成都开设长啸琴馆，吴浸阳为其弟子。
            </td>
          </tr>
          <tr>
            <td>方智</td>
            <td>清末民初</td>
            <td>重庆</td>
            <td>
              字义周。晚年在武汉卖画，善鼓琴，尝弹《渔歌》《醉渔》《渔樵》《风雷引》《梅花》等三十余曲。藏有汉凤凰琴一张，通身作蛇腹断，光彩炫目，声音清脆。
            </td>
          </tr>
          <tr>
            <td>符乾</td>
            <td>清末民初</td>
            <td>巴县</td>
            <td>
              字华轩。善琴，尤工修斫。1919年8月25日在苏州怡园琴会上曾奏《忆故人》。1920年10月12日至14日在上海晨风庐琴会上曾奏《忆故人》《杏坛吟》，会后与郑觐文等编辑《琴书存目》。
            </td>
          </tr>
        </tbody>
        </table>`,
    },
    {
      cont: `<img src="${typedetailimg[1]}" />
            <p>
            说到重庆古琴，就不得不说江北杨家，这是一个经营钱庄起家的富商，也是一门三代的重庆琴人。第一代杨良臣，早年开过钱庄，任过重庆商会会长，投资民生银行、商业银行等多处实业，是相当富有的金融家。业余爱好收藏，亦擅古琴。第二代杨少五（1895～1959年），名世华，他在经商之余，也继承家学，痴迷于古琴，常与重庆琴家及社会名流雅集聚会。杨家财力雄厚，富于收藏，家中藏有多张重量级古琴文物。
          </p>
          <p>
            1945年初，杨少五与来渝的浙派古琴大师徐元白共同发起组织了“天风琴社”，参加者除本地琴人外，还吸收了一批在渝的外地甚至外国琴人，包括一些社会名流，有荷兰人高罗佩、英国人毕铿、国民党元老于右任、冯玉祥以及杨次乾、王迪生、杨清如、陈伍嘉等近三十人。
          </p>
          <p>
            杨少五生有一子三女，长子杨次乾（1911～1951年），从小随父学琴，曾组织重庆的第一个琴社；长女杨清如（1913～1994年），自十三岁起便在其父指导下学琴，三年后又得名师何儒学倾心传授，与其第一任丈夫王迪生都是重庆著名琴人。1956年中央民族音乐研究所进行全国琴人调查时，她还为调查组演奏了六首琴曲，并作了录音。后再嫁成都，第二任丈夫死后于20世纪80年代初回重庆定居，因膝下无子女，与其妹（亦无子女）相依，以教琴为生，1985年被聘为重庆文史馆馆员。
          </p>
          <p>
            据三峡博物馆档案记载，由有关部门转交来的杨少五家藏古琴达二十五张之多，这是我馆古琴最重要的一个来源。
          </p>`,
    },
    {
      cont: `
            <p>
           抗战时期的重庆，文人云集，琴家汇聚。文人、琴人结社雅集，用古琴抗争日本鬼子的大轰炸，琴人们先后结“七弦琴社”“二香琴社”“天风琴社”以自守。  </p>
        <p>在当时重庆的琴社中，影响最大的是“天风琴社”，由本地琴家杨少五和浙派古琴大师徐元白共同发起，社员除了于右任、冯玉祥这样的社会名流，还包括高罗佩这样的荷兰外交官。据记载，高罗佩最常去的地方就是杨少五家，有时晚上就住在杨少五的书房内。</p>
        <p>天风琴社成立于1945年2月25日，即农历乙酉年（民国三十四年）元月十三日，其成立的地点则是在杨少五城里的家——南纪门凤凰台1号大院。</p>
        <p>为何琴社名“天风”？杨少五孙子杨生平先生说：“我们祖上开的钱庄叫‘天顺祥’，我们杨家老院大朝门的牌匾上刻着‘清白家风’，爷爷取两个的头尾，合起来，就是‘天风’”。</p>
        <div class='f'>
            <div class='imgbox'>
              <img src="${typedetailimg[2]}" />
              <p class='tip'>
              • 凤凰台街景
              </p>
            </div>
            <div class='imgbox'>
              <img src="${typedetailimg[3]}" />
              <p class='tip'>
            • 天风琴社成立纪念照片
              </p>
            </div>  
        </div>
        <p>20世纪90年代以来，新一代重庆琴人们广泛交流学习，吸收发扬浙派、虞山派、广陵派、泛川派之琴艺。他们在重庆市民政局注册成立了重庆南山琴社、天风古琴院等组织，广泛开展古琴进高校、古琴艺术研究、琴人雅集等活动，相互切磋研讨、传习观摩，逐步形成自身艺术特色，为保护传承和复兴重庆古琴艺术翻开了新的一页。</p>
           `,
    },
  ];
  return (
    <div className="qsgcdetail-page common-page animate__animated animate__fadeIn">
      <div className="page-l">
        <i />
        <div className="titleall">
          <div className="bigtxt" />
        </div>
        <div
          className="back"
          onClick={() => {
            setType(0);
          }}></div>
      </div>
      <div className={`qsgcdetail-cont qsgcdetail-cont${type}`}>
        <div
          className="scroll"
          dangerouslySetInnerHTML={{
            __html: typedetail1[type - 1].cont,
          }}></div>
      </div>
      <div className="typeactive">
        <img
          src={
            typeimgactive[type - 1]
          }
          alt=""
          style={{ "width": "16.81rem" }}
        />
      </div>
      {/* {type !== 5 && <ul className="qsgcdetail-type">
        {[1, 2, 3, 4].map((item, index) => {
          return (
            <li
              onClick={() => {
                setType(index + 1);
              }}
              key={index}
              className={`animate__animated  animate__fadeInUp animate__delay-0${index + 1
                }s`}>
              <img
                src={
                  type - 1 === index
                    ? typeimgactive[index]
                    : typesmallimg[index]
                }
                alt=""
              />
            </li>
          );
        })}
      </ul>} */}
    </div>
  );
};
const NextArrow = ({ className, style, onClick }) => (
  <div className={cls(className)} onClick={onClick} style={style} />
);
const PrevArrow = ({ className, style, onClick }) => (
  <div className={cls(className)} onClick={onClick} style={style} />
);
function QSGC({ setShow }) {
  const [type, setType] = useState(0);
  const typeimg = Array(5)
    .fill()
    .map((_, index) =>
      require(`../../../assets/images/yzqf/qsgc-type${index + 1}.png`)
    );
  const settings = {
    // className: "center",
    // centerMode: true,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 4.1,
    prevArrow: <PrevArrow className="arrow prevarrow" />,
    nextArrow: <NextArrow />,
  };

  return (
    <div className="common-page qsgccontent-page  animate__animated animate__fadeIn">
      <img src={bg} alt="" />
      <div className="qsgctype">
        <Slider {...settings}>
          {[1, 2, 3, 4, 5].map((item, index) => {
            return (
              <div
                onClick={() => {
                  setType(index + 1);
                }}
                key={index}
                className={`animate__animated  animate__fadeInUp animate__delay-0${index + 1
                  }s`}>
                <div className="imgbox">
                  <img src={typeimg[index]} alt="" />

                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      <div
        className="back"
        onClick={() => {
          setShow("");
        }}></div>
      {type !== 0 && <Detail setType={setType} type={type} />}
    </div>
  );
}

export default QSGC;
